import React, { useRef, useState, useEffect } from "react";
import { Row } from "react-bootstrap";

const WhatsAppAudioPlayer = ({ blobUrl, fileName, isMe }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (audio.paused) {
      audio.play();
      setIsPlaying(true);
    } else {
      audio.pause();
      setIsPlaying(false);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;

    const updateProgress = () => {
      if (audio.duration) {
        setProgress((audio.currentTime / audio.duration) * 100);
      }
    };

    const onLoadedMetadata = () => {
      setDuration(audio.duration);
    };

    const onEnded = () => {
      setIsPlaying(false);
      setProgress(0);
    };

    audio.addEventListener("timeupdate", updateProgress);
    audio.addEventListener("loadedmetadata", onLoadedMetadata);
    audio.addEventListener("ended", onEnded);

    return () => {
      audio.removeEventListener("timeupdate", updateProgress);
      audio.removeEventListener("loadedmetadata", onLoadedMetadata);
      audio.removeEventListener("ended", onEnded);
    };
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <div className="w-full mb-3">
      <Row className="items-center">
        <p className={`${isMe ? `text-white` : `text-blue-500`} mb-2`}>
          {fileName}
        </p>
        <div className="flex items-center gap-3 w-full">
          <button
            onClick={togglePlayPause}
            className={`${
              isMe ? `text-white` : `text-blue-500`
            } text-xl focus:outline-none`}
          >
            <i
              className={`bi ${isPlaying ? "bi-pause-fill" : "bi-play-fill"}`}
            />
          </button>

          <div className="flex flex-col w-full">
            <div
              className={`w-full h-1 bg-gray-100 rounded overflow-hidden mb-1  ${
                isMe ? `text-white` : `text-blue-500`
              }`}
            >
              <div
                className="h-full bg-gray-600"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div
              className={`flex justify-between text-xs  ${
                isMe ? `text-white` : `text-blue-500`
              }`}
            >
              <span>{formatTime((progress / 100) * duration)}</span>
              <span>{formatTime(duration)}</span>
            </div>
          </div>
        </div>
        <audio ref={audioRef} src={blobUrl} preload="metadata" />
      </Row>
    </div>
  );
};

export default WhatsAppAudioPlayer;
